// extracted by mini-css-extract-plugin
export default {"avatar":"userdetails_avatar__H-D87","email":"userdetails_email__AvbDS","logout__button":"userdetails_logout__button__fEaIU","logout__icon":"userdetails_logout__icon__4vz2A"};